import React from "react";

// Simplified series editor for templates: only the number of series matters
// (no reps / weight / RPE — those are filled in per student when the template is used).
export default function TemplateSeriesControl({ count, onAdd, onRemove }) {
	return (
		<div className="editor-template-series">
			<span className="editor-template-series-label">Séries</span>
			<div className="editor-template-series-stepper">
				<button
					type="button"
					className="editor-template-series-btn"
					onClick={onRemove}
					disabled={count <= 1}
					aria-label="Retirer une série"
				>
					−
				</button>
				<span className="editor-template-series-count">{count}</span>
				<button
					type="button"
					className="editor-template-series-btn"
					onClick={onAdd}
					aria-label="Ajouter une série"
				>
					+
				</button>
			</div>
		</div>
	);
}
